import { Box, Grid } from '@mui/material';
import React, { FC, useMemo } from 'react';
import StyledBox from 'views/rebranded-module/events-module/MotorcycleEventsDetailsView/components/EventTitleSection/EventTitleSection.styles';
import { Share, BreadcrumbsV2, Typography700 } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
interface EventTitleSectionProps {
  eventTitle?: string;
}

const EventTitleSection:FC<EventTitleSectionProps> = (props) => {
  const { eventTitle } = props;
  const content = useContent('EventDetailsPage');
 const breadcrumbsObject = useMemo(() => {
  return {
    links: [
      {
        text: content.eagleRider,
        path: PATHS.home(),
      },
      {
        text: content.motorcycleEventsCapitalLetters,
        path: PATHS.motorcycleEvents.index(),
      },
      {
        text: eventTitle,
        path: '',
      },
    ],
  };
}, [content, eventTitle]);

  return (
    <StyledBox>
      <BreadcrumbsV2 data={breadcrumbsObject} />
      <Grid container  alignItems="center" className="ETSTitleContainer">
        <Grid item xl={7.75} lg={7} md={8} sm={9.5}>
          <Typography700 variant="h4" component="h1">
            {eventTitle}
          </Typography700>
        </Grid>
        <Grid item xl={4.25} lg={5} md={4} sm={2.5}>
          <Box display="flex" justifyContent="flex-end">
            <Share
              journeyName={eventTitle}
              shareModalTitle={content.shareModalTitle}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export { EventTitleSection };